import cx from 'classnames';

import { TariffType, tariffDisplayData } from '@/config';

import styles from './TariffBadge.module.sass';

interface TariffBadgeProps {
  tariff: TariffType;
  className?: string;
}

const TariffBadge = ({ tariff, className }: TariffBadgeProps) => {
  const classes = cx(
    styles.badge,
    {
      [styles[tariff]]: !!tariff,
    },
    className,
  );

  return (
    <div className={classes}>
      <span>{tariffDisplayData[tariff].title}</span>
    </div>
  );
};

export default TariffBadge;
